import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';

export interface DiscountValues {
	percentageDiscount: number;
	purchaseThreshold: number;
}

export type UseDiscountValues = Nullable<DiscountValues>;

export const useDiscountValues = (): UseDiscountValues => {
	const isBuy2Group = useFeatureToggle(FEATURES.promotionsDiscountBuy2Group);
	const isBuy6Group = useFeatureToggle(FEATURES.promotionsDiscountBuy6Group);
	const isBuy11Group = useFeatureToggle(FEATURES.promotionsDiscountBuy11Group);
	const isBuy25Group = useFeatureToggle(FEATURES.promotionsDiscountBuy25Group);

	if (isBuy2Group) {
		return { percentageDiscount: 15, purchaseThreshold: 2 };
	}

	if (isBuy6Group) {
		return { percentageDiscount: 20, purchaseThreshold: 6 };
	}

	if (isBuy11Group) {
		return { percentageDiscount: 23, purchaseThreshold: 11 };
	}

	if (isBuy25Group) {
		return { percentageDiscount: 25, purchaseThreshold: 25 };
	}

	return null;
};
